// @flow
import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { getHomeUrl } from 'utils/searchHomePages';
import { H5 } from 'components/Text';
import Link from 'components/Link';
import { Line } from 'components/SearchLoadingSection';
import AnimatedCounter from 'components/AnimatedCounter';
import {
  LISTING_TYPE_HUMAN_NAME_MAP_COUNTS,
  LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_COUNTS
} from 'utils/constants';
import Box from 'components/Box';
import { isEnabled as daysEnabled } from 'utils/idealistdayevents';
import { transition } from '../theme';

const aFadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const AnimateIn = styled(Box)`
  animation: ${aFadeIn} ${transition} forwards;
`;

const ListingCounts = ({
  listingCounts
}: {
  listingCounts: ?{ [string]: number }
}) => {
  const types = ['JOB', 'INTERNSHIP', 'VOLOP', 'ORG', 'GROUP', 'GRAD_PROGRAM'];
  return (
    <Box
      data-qa-id="listing-counts"
      width="calc(100% + 16px)"
      minHeight={30}
      mx="-8px"
      textAlign="center"
    >
      {listingCounts ? (
        <AnimateIn
          display="flex"
          justifyContent={['center', null, null, 'space-between']}
          flexWrap="wrap"
        >
          {[...types, ...(daysEnabled() ? ['IDEALIST_DAY_EVENT'] : [])].map(
            type => {
              const count = listingCounts[type] || 0;
              return (
                <Box mx="8px" key={type}>
                  <Link href={getHomeUrl(type, { q: '', searchMode: 'true' })}>
                    <H5 tag="span">
                      <AnimatedCounter count={count} fixedWidth />{' '}
                      {count === 1
                        ? LISTING_TYPE_HUMAN_NAME_MAP_COUNTS[type]
                        : LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_COUNTS[type]}
                    </H5>
                  </Link>
                </Box>
              );
            }
          )}
        </AnimateIn>
      ) : (
        <Box
          display="flex"
          justifyContent={['center', null, null, 'space-between']}
          flexWrap="wrap"
        >
          {new Array(types.length).fill().map((_, index) => (
            <Line
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              flex="0 0 auto"
              width={120}
              maxWidth="calc(50% - 16px)"
              height={16}
              m="8px"
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ListingCounts;
